import { Observable } from 'rxjs';
import { LoginDTO, LoginResponseDTO } from '../../../data/dto/LoginDTO';

export abstract class UserRepository {
  abstract login(auth: LoginDTO): Observable<LoginResponseDTO>;
  abstract logout(): Observable<string>;
}
